// src/Pages/AdminManagment/AddAdmin.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import { successToast, errorToast } from "../../Utils/toast";
import { useCreateAdminMutation } from "../../redux/services/sabAdminService/admin.Services";
import { useGetWaadDropdownQuery } from "../../redux/services/waadService/waad.Services";

function AddAdmin() {
    const navigate = useNavigate();
    const [createAdmin, { isLoading }] = useCreateAdminMutation();
    const { data: waadData, isLoading: waadLoading } = useGetWaadDropdownQuery();

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        password: "",
        waad_id: "",
        waad_name: "",
        role: "sub_admin", // admin, sub_admin
        status: 1,
    });

    const [errors, setErrors] = useState({});

    // Auto-fill waad_name
    useEffect(() => {
        if (formData.waad_id) {
            const selectedWaad = waadData?.data?.find(w => w.id == formData.waad_id);
            if (selectedWaad) {
                setFormData(prev => ({
                    ...prev,
                    waad_name: selectedWaad.waad_name
                }));
            }
        } else {
            setFormData(prev => ({
                ...prev,
                waad_name: ""
            }));
        }
    }, [formData.waad_id, waadData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        let finalValue = value;
        if (name === "status") {
            finalValue = parseInt(value);
        }
        setFormData({
            ...formData,
            [name]: finalValue,
        });
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: "",
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = "Name is required";
        }
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }
        if (formData.mobile && !/^[0-9]{10}$/.test(formData.mobile)) {
            newErrors.mobile = "Mobile must be 10 digits";
        }
        if (!formData.password.trim()) {
            newErrors.password = "Password is required";
        } else if (formData.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters";
        }
        if (formData.role === "sub_admin" && !formData.waad_id) {
            newErrors.waad_id = "Please select a waad for sub admin";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        try {
            const payload = {
                name: formData.name,
                email: formData.email,
                mobile: formData.mobile || null,
                password: formData.password,
                waad_id: formData.role === "sub_admin" ? parseInt(formData.waad_id) : null,
                waad_name: formData.role === "sub_admin" ? formData.waad_name : null,
                role: formData.role,
                status: formData.status,
            };

            const response = await createAdmin(payload).unwrap();
            successToast(response.message || "Sub Admin Created Successfully");
            navigate("/admin-list");
        } catch (error) {
            console.log("Create admin error:", error);
            errorToast(error?.data?.message || "Failed to create sub admin");
        }
    };

    const getRoleLabel = (role) => {
        const roles = {
            'admin': 'Admin',
            'sub_admin': 'Sub Admin'
        };
        return roles[role] || role;
    };

    return (
        <div>
            {/* HEADER */}
            <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">Add Sub Admin</h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item active"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/admin-list">Admin List</Link></li>
                            <li className="breadcrumb-item">Add Sub Admin</li>
                        </ol>
                    </nav>
                </div>
                <div className="page-title fw-semibold fs-18 mb-0">
                    <button className="btn btn-primary me-2" onClick={() => navigate("/admin-list")}>
                        <i className="fe fe-list me-1"></i> Admin List
                    </button>
                </div>
            </div>

            {/* FORM */}
            <div className="card">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    {/* NAME */}
                                    <div className="form-group">
                                        <label>Name <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                            placeholder="Enter Name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                    </div>
                                </div>
                                <div className="col-md-6">


                                    {/* EMAIL */}
                                    <div className="form-group mt-3">
                                        <label>Email <span className="text-danger">*</span></label>
                                        <input
                                            type="email"
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                            placeholder="Enter Email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                    </div>
                                </div>
                                <div className="col-md-6">


                                    {/* MOBILE */}
                                    <div className="form-group mt-3">
                                        <label>Mobile</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.mobile ? 'is-invalid' : ''}`}
                                            placeholder="Enter Mobile (10 digits)"
                                            name="mobile"
                                            value={formData.mobile}
                                            onChange={handleChange}
                                            maxLength="10"
                                        />
                                        {errors.mobile && <div className="invalid-feedback">{errors.mobile}</div>}
                                    </div>
                                </div>
                                <div className="col-md-6">


                                    {/* PASSWORD */}
                                    <div className="form-group mt-3">
                                        <label>Password <span className="text-danger">*</span></label>
                                        <input
                                            type="password"
                                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                            placeholder="Enter Password (min 6 chars)"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                        />
                                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                    </div>
                                </div>
                                <div className="col-md-6">

                                    {/* ROLE */}
                                    <div className="form-group mt-3">
                                        <label>Role <span className="text-danger">*</span></label>
                                        <select
                                            name="role"
                                            className="form-control"
                                            value={formData.role}
                                            onChange={handleChange}
                                        >
                                            <option value="admin">Admin</option>
                                            <option value="sub_admin">Sub Admin</option>
                                        </select>
                                        <small className="text-muted">
                                            {formData.role === 'admin' && 'Full access to everything'}
                                            {formData.role === 'sub_admin' && 'Limited access with permissions'}
                                        </small>
                                    </div>
                                </div>
                                <div className="col-md-6">

                                    {/* WAAD (Only for Sub Admin) */}
                                    {formData.role === "sub_admin" && (
                                        <div className="form-group mt-3">
                                            <label>Select Waad <span className="text-danger">*</span></label>
                                            <select
                                                name="waad_id"
                                                className={`form-control ${errors.waad_id ? 'is-invalid' : ''}`}
                                                value={formData.waad_id}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Waad</option>
                                                {waadData?.data?.map((waad) => (
                                                    <option key={waad.id} value={waad.id}>
                                                        {waad.waad_name} {waad.waad_code ? `(${waad.waad_code})` : ''}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.waad_id && <div className="invalid-feedback">{errors.waad_id}</div>}
                                            {waadLoading && <small className="text-muted">Loading waads...</small>}
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-6">


                                    {/* STATUS */}
                                    <div className="form-group mt-3">
                                        <label>Status</label>
                                        <select
                                            name="status"
                                            className="form-control"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option value={1}>Active</option>
                                            <option value={0}>Inactive</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">

                                    {/* BUTTONS */}
                                    <div className="form-group mt-4">
                                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                            {isLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Creating...
                                                </>
                                            ) : (
                                                "Create Sub Admin"
                                            )}
                                        </button>
                                        <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate("/admin-list")}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
            </form>
        </div>
            </div >
        </div >
    );
}

export default AddAdmin;